import React, { useCallback } from 'react';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Tooltip } from '@televet/kibble-ui/build/components/Tooltip';
import useAppointmentCalendarCurrentDay from 'pages/Appointments/hooks/useAppointmentCalendarCurrentDay';
import {
  getPersistedAppointmentFilters,
  setPersistedAppointmentFilters,
} from 'shared/providers/ApolloProvider/reactiveVars/appointmentFilters';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import { useAppSelector } from 'state/hooks';

const JumpToTodayButton = (): JSX.Element => {
  const { setCurrentDay } = useAppointmentCalendarCurrentDay();
  const wallpaperMode = useAppSelector((state) => state.currentClinic.wallpaperMode);

  const todayClicked = useCallback(() => {
    const filters = getPersistedAppointmentFilters();

    setPersistedAppointmentFilters({
      ...filters,
      currentDay: new Date(),
      startDate: startOfDay(new Date()),
      endDate: endOfDay(new Date()),
    });
    setCurrentDay(new Date());
  }, [setCurrentDay]);

  return (
    <Tooltip label="Jump to today">
      <Button
        variant="secondary"
        size="sm"
        data-mixpanel-name="Today button"
        data-testid="today-button"
        {...(wallpaperMode ? { bg: 'white !important' } : {})}
        onClick={todayClicked}
      >
        <span>Today</span>
      </Button>
    </Tooltip>
  );
};

export default JumpToTodayButton;
